import { render, staticRenderFns } from "./NewConversation.modal.vue?vue&type=template&id=1ff5a4a3&scoped=true&"
import script from "./NewConversation.modal.vue?vue&type=script&lang=js&"
export * from "./NewConversation.modal.vue?vue&type=script&lang=js&"
import style0 from "./NewConversation.modal.vue?vue&type=style&index=0&id=1ff5a4a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff5a4a3",
  null
  
)

export default component.exports